import * as types from '../actionTypes/candidateBoard'

let defaultState = {
  currentCandidateBoards: [],
  currentCandidateBoard: {}
}

const candidateBoardReducer = (state = defaultState, action) => {
  if (action.type === types.GET_CANDIDATEBOARD) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.candidateBoard) {
      action.candidateBoard = {}
    } else {
      action.candidateBoard = {
        ...action.candidateBoard,
      }
    }
    return {
      ...state,
      currentCandidateBoard: action.candidateBoard
    }
  }
  else if (action.type === types.GET_CANDIDATEBOARD_FOR_CANDIDATE) {
    return {
      ...state,
      currentCandidateBoards: action.candidateBoards
    }
  }
  else if (action.type === types.UPDATE_CANDIDATEBOARD_FOR_CANDIDATE) {
    return {
      ...state,
      currentCandidateBoard: action.candidateBoard
    }
    /*
    return {
      ...state,
      candidateBoards: state.currentCandidateBoards.map(board => {
        return board.CandidateBoardId === action.board.CandidateBoardId ?
          {
            ...action.board
          } :
          {
            ...board
          }
      })
    } */
  }
  else if (action.type === types.ADD_CANDIDATEBOARD_TO_CANDIDATE) {
    return {
      ...state,
      currentCandidateBoard: action.candidateBoard
    //  candidateBoards: state.candidateBoards.concat({
    //    ...action.board
    //  })
    }
  }
  else if (action.type === types.REMOVE_CANDIDATEBOARD_FROM_CANDIDATE) {
    return {
      ...state,
     //  currentCandidateBoard: action.candidateBoard
     // candidateBoards: state.candidateBoards.filter(candidateBoard => candidateBoard.CandidateBoardId !== action.CandidateBoardId)
    }
  }
  else if (action.type === types.CLEAR_CANDIDATEBOARD) {
    return {
      ...state,
      currentCandidateBoard: {}
    }
  }
  else if (action.type === types.CLEAR_CANDIDATEBOARD_FOR_CANDIDATE) {
    return {
      ...state,
      boards: []
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default candidateBoardReducer;


// WEBPACK FOOTER //
// ./src/reducers/candidateBoard.js